import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import icons from './icons';

class Icon extends Component {
	render() {
		const { icon, className, onClick, children } = this.props;

		return (
			<div
				onClick={() => {
					onClick && onClick();
				}}
				className={`${className || ''} icon`}
				style={{ backgroundImage: `url(${icons[icon]})` }}
			>
				{children}
			</div>
		);
	}
}

Icon.propTypes = {
	icon: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default Icon;
